

import Vue from 'vue'
import Component from "vue-class-component";
import {EOrderTypes} from "@/model/Order/orderInterfaces";
import {Prop} from "vue-property-decorator";
import { UrlHelper } from '@/helpers/UrlHelper';
import {IChipStyle, IChipStyles} from "@/model/chipStyleInterfaces";
import {icons} from "@/plugins/icons";

// @todo this should apply chip styles/icons etc
@Component({})
export default class OrderChip extends Vue {

  @Prop()
  protected orderId!: number;

  public static readonly chipStyles: IChipStyles = {
    [EOrderTypes.amazon_return]: {
      color: '#F4A520',
      icon: icons.orders.types.amazon_return,
    },
    [EOrderTypes.bizcocho_order]: {
      color: '#20E7F4',
      icon: icons.orders.types.bizcocho_order,
    },
    [EOrderTypes.custom]: {
      color: '#9CFFF9',
      icon: icons.orders.types.custom,
    },
    [EOrderTypes.delivery_with_code]: {
      color: '#18FFBE',
      icon: icons.orders.types.delivey_with_code,
    },
    [EOrderTypes.drop_only]: {
      color: 'x00DD9E',
      icon: icons.orders.types.drop_only,
    },
    [EOrderTypes.home_delivery]: {
      color: '#68B6FE',
      icon: icons.orders.types.home_delivery,
    },
    [EOrderTypes.internal_delivery_1]: {
      color: '#A3D3FF',
      icon: icons.orders.types.internal_delivery_1,
    },
    [EOrderTypes.laundry_drop_go]: {
      color: '#FDFF8E',
      icon: icons.orders.types.laundry_drop_go,
    },
    [EOrderTypes.locker_order]: {
      color: '#CCF475',
      icon: icons.orders.types.locker_order,
    },
    [EOrderTypes.office_order]: {
      color: '#B8DF64',
      icon: icons.orders.types.office_order,
    },
    [EOrderTypes.package_transfer]: {
      color: '#9ECE36',
      icon: icons.orders.types.packageTransfer,
    },
    [EOrderTypes.public_locker]: {
      color: '#86C6CF',
      icon: icons.orders.types.public_locker,
    },
    [EOrderTypes.smart_drop]: {
      color: '#B4E6EE',
      icon: icons.orders.types.smart_drop,
    },
    [EOrderTypes.smart_storage]: {
      color: '#f8c',
      icon: icons.orders.types.smart_storage,
    },
    unknown: {
      color: 'red',
      icon: icons.orders.types.unknown,
    },
    // NOTE this is a service provider type but we reuse order type icons there (and someday this'd be a supermarket type)
  }

  public static chipStyleOf(type: string): IChipStyle {
    return OrderChip.chipStyles[type] ||OrderChip.chipStyles['unknown'];
  }

  protected UrlHelper: UrlHelper = UrlHelper;

  protected linkToOrder() {
    return {name:'order',params: {orderId:this.orderId}}
  }

}

